import { useEffect } from 'react'

import { uncheckUnsetCookieYesCategories } from 'utils/cookieYesDefaultToggles'

const SETTINGS_TRIGGER_SELECTOR = '.cky-btn-customize, [data-cky-tag="settings-button"]'

/**
 * OneTrust handleOneTrustLoad karşılığı: karar yokken "Tercihler"e tıklanınca
 * C0002/C0003/C0004 karşılığı CookieYes anahtarlarını kapatır.
 *
 * Banner yüklenirken kapatmak yetmez: CookieYes anahtarları DOM'a girdikten sonra
 * `setTimeout(0)` ile `defaultConsent`'e (enuygun'da hepsi açık) göre yeniden işaretler.
 * Bu yüzden kapatma tercih merkezi açılırken, CookieYes'in kendi click handler'ından sonra yapılır.
 */
const useCookieYesDefaultToggles = (enabled: boolean): void => {
  useEffect(() => {
    if (!enabled || typeof window === 'undefined') return undefined

    const timeouts: number[] = []

    const handleSettingsClick = (event: Event): void => {
      const target = event.target
      if (!(target instanceof Element) || !target.closest(SETTINGS_TRIGGER_SELECTOR)) return
      timeouts.push(window.setTimeout(() => uncheckUnsetCookieYesCategories(), 0))
    }

    document.addEventListener('click', handleSettingsClick)

    return () => {
      document.removeEventListener('click', handleSettingsClick)
      timeouts.forEach((id) => window.clearTimeout(id))
    }
  }, [enabled])
}

export default useCookieYesDefaultToggles
